import { auth, requestState } from "../actions/index";

export default (initialState, action) => {
	switch (action.type) {
		case requestState.LOADING:
			return {
				...initialState,
				loading: true,
			};

		case requestState.LOADED:
			localStorage.setItem("_id", action.payload._id);
			localStorage.setItem("subscription", action.payload?.subscription);
			localStorage.setItem("user", JSON.stringify(action.payload));
			return {
				...initialState,
				...action.payload,
				isAuthenticated: true,
				loading: false,
				token: localStorage.getItem("token"),
			};

		case auth.LOGIN_SUCCESS:
			return {
				...initialState,
				...action.payload,
				isAuthenticated: true,
				loading: false,
			};
		case auth.UPDATE_PROFIL:
			localStorage.removeItem('user')
			localStorage.setItem("user", JSON.stringify(action.payload));
			return {
				...initialState,
				...action.payload,
				isAuthenticated: true,
				loading: false,
				success: "Profile updated",
			};

		case auth.LOGIN_FAIL:
			localStorage.removeItem("token");
			return {
				...initialState,
				token: null,
				isAuthenticated: false,
				loading: false,
				userAuthenticated: null,
				error: action.payload,
			};
		case requestState.ERROR:
			return {
				...initialState,
				error: action.payload,
				loading: false,
			};
		case auth.LOGOUT:
			localStorage.removeItem("token");
			localStorage.removeItem('user');
			localStorage.removeItem("code");
			localStorage.removeItem("currentSubscription");
			return {
				...initialState,
				token: null,
				isAuthenticated: false,
				loading: false,
				userAuthenticated: null,
				error: null,
			};

		case requestState.CLEAR_NOTIFICATION:
			return {
				...initialState,
				error: null,
				success: null,
			};
		default:
			return initialState;
	}
};
